module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a_RM"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('h2', {
    staticClass: "toc-fronta"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_01"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("1")]), _vm._v(" “Nothing but Divisions Among Our People”")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("2")]), _vm._v(" “Rich Man’s War”")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("3")]), _vm._v(" “Fighting Each Other Harder Than We Ever Fought the Enemy”")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("4")]), _vm._v(" “Yes, We All Shall Be Free”")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("5")]), _vm._v(" “Now the Wolf Has Come”")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("6")]), _vm._v(" “Defeated … by the People at Home”")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-back"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-backa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-backa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INDEX")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d8ca3d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0